import { PollFormValues, CreatePollRequest } from 'types';
import { removeExtraSpaces } from 'utils';

import { getUTCDate } from '../../utils';
import { AllOption } from './constants';

export function formValuesAdapter({
  title,
  description,
  visibility,
  deadline,
  options,
}: PollFormValues): CreatePollRequest {
  const formattedOptions = options
    .map(({ value }) => removeExtraSpaces(value))
    .filter((value) => !!value);

  const group_visibility =
    visibility?.length === 1 && visibility.includes(AllOption.value) ? 'all' : 'custom';
  const visibilities =
    visibility?.length === 1 && visibility.includes(AllOption.value) ? undefined : visibility;
  return {
    title: removeExtraSpaces(title),
    description: removeExtraSpaces(description),
    type: 'polls',
    ...(visibilities && { assigned_to: visibilities }),
    group_visibility,
    poll: {
      options: formattedOptions,
      ...(deadline && { deadline: getUTCDate(deadline) }),
    },
  };
}
